module.exports = new __parcel__URL__("practitionerIcon.464446bc.svg").toString();